// mixins/chatBubble.js
import { mapGetters } from "vuex";

export default {
  created() {
    if (process.client) {

      this.$chat.hideChat();
      this.handleChatBubbleVisibility();
    }
  },

  computed: {
    ...mapGetters({
      toogleSignIn: "toogleSignIn",
    }),
  },

  watch: {
    '$route'() {
      if (process.client) {
        this.$chat.hideChat();
        this.handleChatBubbleVisibility();
      }
    },
    toogleSignIn(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$chat.toggleBubbleVisibility(newValue ? 'hide' : 'show');
      }
    }
  },

  methods: {
    shouldShowChat() {
      return this.$route.path.match(/^\/book\/[^\/]+\/[^\/]+\/[^\/]+$/) ||
        this.$route.path.match(/^\/checkout\/\d+$/);
    },

    handleChatBubbleVisibility() {
      const action = this.shouldShowChat() ? 'show' : 'hide';
      console.log(`${action} chat bubble`);
      this.$chat.toggleBubbleVisibility(action);
    }
  }
};
